import { typeConsts } from "../../cadendar-consts.js";
const filterOutCanceledAndCurrentRdvs = (rdvs, rdv) => {
    if (rdv) {
        return rdvs.filter((r) => !rdvIsCancelled(r) && !haveSameId(r, rdv));
        // return _.chain(rdvs)
        //   .reject(rdvIsCancelled)
        //   .reject(curry2(haveSameId)(rdv))
        //   .value();
    }
    else {
        return rdvs.filter((r) => !rdvIsCancelled(r));
    }
};
const haveSameId = (rdv1, rdv2) => {
    "use strict";
    if (!rdv1 || !rdv2) {
        return false;
    }
    return rdv1.id === rdv2.id;
};
const rdvIsCancelled = function (rdv) {
    return rdv.type === typeConsts.ANN || rdv.type === typeConsts.ANNTARD;
};
export default filterOutCanceledAndCurrentRdvs;
//# sourceMappingURL=filterOutCanceledAndCurrentRdvs.js.map